import React from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

import './style.scss'

export class NavTabs extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      offset: 0,
      sticky: false,
    }

    this.linkRefs = []
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
    const menuOffset = document.getElementById('navTab').offsetTop
    this.setState({ offset: menuOffset })
  }

  handleScroll = () => {
    const currentScroll = window.pageYOffset
    const sticky = this.state.offset < currentScroll

    this.setState({ sticky })
  }

  render() {
    return (
      <ul className={'nav-tabs ' + (this.state.sticky && 'sticky')} id="navTab">
        {this.props.children}
      </ul>
    )
  }
}

export class NavTabsItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: 'Guideline & Best Practices',
      class: 'nav-tabs__link',
    }
  }

  onClick(item) {
    this.setState({ active: item })
    console.log(this.state.active + item + this.state.class)
    if (this.state.active === item) {
      this.setState({ class: 'nav-tabs__link nav-tabs__link--active' })
    }
  }

  render() {
    return (
      <li className="nav-tabs__item">
        <AnchorLink
          href={'#' + this.props.anchor}
          onClick={e => this.onClick(this.props.children)}
          class={this.state.class}
        >
          {this.props.children}
        </AnchorLink>
      </li>
    )
  }
}
